<template>
    <div class="shipIndex-ship-item">
        <div class="shipIndex-ship-itemPic">
            <img :src="ship.image" :alt="ship.shipCNName">
        </div>
        <div class="shipIndex-ship-itemName">
            <div>
                <p class="shipIndex-ship-itemCName">{{ship.shipCNName}}</p>
                <p class="shipIndex-ship-itemEName">{{ship.shipENName}}</p>
                <p class="shipIndex-ship-itemPort" v-if="!isRow"><span>{{ship.departure}}</span>出发</p>
                <p class="shipIndex-ship-itemPort" v-else>{{ship.departure}}</p>
            </div>
        </div>
        <div class="shipIndex-ship-itemInfo">
            <div>
                <div class="shipIndex-ship-itemInfoIcon">
                    <img class="shipIndex-ship-itemNum"
                        src="https://resource.rcclchina.com.cn/mobileShip/shipIcon1.png">
                </div>
                <div class="shipIndex-ship-itemInfoTxt">

                    <p>{{ship.capacity}}</p>
                    <p class="shipIndex-ship-itemUnit">载客人数</p>
                </div>
            </div>
            <div>
                <div class="shipIndex-ship-itemInfoIcon">
                    <img class="shipIndex-ship-itemWeight"
                        src="https://resource.rcclchina.com.cn/mobileShip/shipIcon2.png">
                </div>
                <div class="shipIndex-ship-itemInfoTxt">

                    <p>{{ship.weight}}</p>
                    <p class="shipIndex-ship-itemUnit">吨位</p>
                </div>
            </div>
        </div>
        <div class="shipIndex-ship-itemVR" v-if="ship.vrLink&&ship.vrLink.length>0">
            <a :href="ship.vrLink" class="hold-link external" target="_blank">
                <img src="https://resource.rcclchina.com.cn/mobileShip/shipVRIcon.png">
            </a>
        </div>
        <a class="hold-shipLink external" :href="ship.link"></a>
    </div>
</template>

<script>
export default {
    name: "ShipIndexItem",
    props: {
        ship: {
            type: Object
        },
        isRow: {
            type: Boolean
        }
    }
}
</script>

<style lang="less" scoped>

.shipIndex-ship-item {
    position:relative;
}
.shipIndex-ship-itemPic {
    width:100%;
    height:133px;
    margin-top: 15px;
    overflow:hidden;
}
.shipIndex-ship-itemPic img{
    width:100%;
}
.shipIndex-ship-itemName {
    background-color: rgba(0,0,0,.3);
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content:center;
    align-items:center;
    position:absolute;
    top:0;
    left:0;
    text-align:center;
}
.shipIndex-ship-itemName p{
    margin:0;
    color:#fff;
}
.shipIndex-ship-itemCName {
    font-size:18px;
}
.shipIndex-ship-itemEName {
    font-size: 16px;
    font-style: italic;
}
.shipIndex-ship-itemPort {
    font-size:13px;
}
.shipIndex-ship-itemInfo {
    position:absolute;
    bottom:7px;
    left:11px;
}
.shipIndex-ship-itemInfo>div{
    margin-bottom:3px;
}
.shipIndex-ship-itemInfo .shipIndex-ship-itemInfoIcon {
    width: 30px;
    height: 30px;
    text-align: center;
    background-color: rgba(255,255,255,.3);
    border-radius: 2px;
    display: inline-block;
    vertical-align: bottom;
}
.shipIndex-ship-itemInfo .shipIndex-ship-itemNum {
    width: 21px;
    height: 14px;
    vertical-align:middle;
}
.shipIndex-ship-itemWeight {
    width: 17px;
    height: 18px;
    vertical-align: middle;
}
.shipIndex-ship-itemInfo .shipIndex-ship-itemInfoTxt {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
}
.shipIndex-ship-itemInfo > div p {
    margin:0;
    font-size:13px;
    color:#fff;
}
.shipIndex-ship-itemUnit {
    transform: scale(.83);
    -webkit-transform: scale(.83);
    -moz-transform: scale(.83);
    -o-transform: scale(.83);
    margin: -4px 0 0 -5px !important;
}
.shipIndex-ship-itemVR {
    position:absolute;
    right:10px;
    bottom:10px;
    width:30px;
    height:30px;
    z-index:33;
}
.shipIndex-ship-itemVR .hold-link {
    width:100%;
    height:100%;
    display:inline-block;
}
.shipIndex-ship-itemVR img {
    width: 100%;
}
.hold-shipLink {
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index:22;
}
</style>